module.exports = __webpack_public_path__ + "./img/man-logo.svg";